module.exports = __webpack_public_path__ + "static/media/pe.b6aec00c.svg";